<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-sidebar ref="productSidebar" />

    <div class="flex justify-between">
      <p>This is the overall list of all stock products that may be assigned to venues</p>
      <div class="flex justify-end">
        <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3">Add new</vs-button>
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredStockProducts" @selected="onClicked">
        <template slot="header">
          <div class="flex mb-2">
            <vs-select v-model="filters.category" autocomplete class="w-1/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.category" />
            </vs-select>

            <vs-select v-model="filters.vendor" autocomplete class="ml-2 w-1/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.vendor" />
            </vs-select>

            <vs-select v-model="filters.status" autocomplete class="ml-2 w-1/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.status" />
            </vs-select>
          </div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <!-- <vs-th sort-key="number">Number</vs-th> -->
          <vs-th sort-key="name">Name</vs-th>
          <vs-th>Category</vs-th>
          <vs-th>Vendor</vs-th>
          <vs-th sort-key="unitPrice">Unit price</vs-th>
          <vs-th sort-key="inactive">Status</vs-th>
          <vs-th sort-key="createdAt">Created at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="ProductIcon" />
                    <div class="ml-4">
                      <div v-if="tr.name">
                        {{ tr.name }}
                      </div>
                      <div v-else>
                        <vs-chip> No name </vs-chip>
                      </div>
                      <small>{{ tr.number }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.productCategoryId">
                  {{ productCategories.find(e => e.productCategoryId.id === tr.productCategoryId).name }}
                </div>
                <div v-else>
                  <vs-chip>No category</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.vendorId">
                  {{
                    vendors.find(e => e.vendorId.id === tr.vendorId) != null ? vendors.find(e => e.vendorId.id === tr.vendorId).name : ""
                  }}
                </div>
                <div v-else>
                  <vs-chip>No vendor</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                {{ tr.unitPrice }}
                DKK
              </vs-td>
              <vs-td>
                <vs-chip :color="tr.inactive ? 'danger' : ''">
                  {{ tr.inactive ? "Locked " : "Unlocked" }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div v-if="tr.createdAction" class="flex">
                  <feather-icon class="mr-1" :icon="'CalendarIcon'" svgClasses="text-grey w-5 h-5" />
                  {{ tr.createdAction.timestamp | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductSidebar from "./StockProductSidebar.vue";

export default {
  components: {
    HandleProductSidebar
  },
  data() {
    return {
      isLoading: true,
      ProductIcon,

      filters: {
        category: null,
        vendor: null,
        status: null
      }
    };
  },
  methods: {
    onClicked(item) {
      this.$refs.productSidebar.show(item.id);
    },
    async onClickCreateNew() {
      this.$refs.productSidebar.showEmptyProduct();
    }
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      stockProducts: "pos/stockProducts/stockProducts",
      countries: "pos/countries/countries",
      productCategories: "pos/countrySettings/stockCategories",
      pouringCategories: "pos/countrySettings/pouringCategories",
      vendors: "pos/vendors/vendors"
    }),

    selectableFilters() {
      return {
        category: [
          { text: "Filter by category", value: null },
          ...this.productCategories.map(e => ({
            text: e.name,
            value: e.productCategoryId.id
          }))
        ],
        vendor: [
          { text: "Filter by vendor", value: null },
          ...this.vendors.map(e => ({
            text: e.name,
            value: e.vendorId.id
          }))
        ],
        status: [
          { text: "Filter by status", value: null },
          { text: "Locked", value: 1 },
          { text: "Unlocked", value: 2 }
        ]
      };
    },

    filteredStockProducts() {
      return this.stockProducts
        .filter(e => {
          if (this.filters.category && e.productCategoryId != this.filters.category) {
            return false;
          }

          if (this.filters.vendor && e.vendorId != this.filters.vendor) {
            return false;
          }

          if (this.filters.status == 1 && !e.inactive) {
            return false;
          }

          if (this.filters.status == 2 && e.inactive) {
            return false;
          }

          return true;
        })
        .slice()
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    }
  },

  async created() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch("pos/stockProducts/getStockProducts"),
      this.$store.dispatch("pos/countrySettings/getCountrySettings"),
      this.$store.dispatch("pos/vendors/getVendors")
    ]);
    this.isLoading = false;
  }
};
</script>